import { render, staticRenderFns } from "./createPromo.vue?vue&type=template&id=08cf2a6f&"
import script from "./createPromo.vue?vue&type=script&lang=js&"
export * from "./createPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports